import "../../../assets/scss/widgets/progressbar.scss";
import { round } from "../../../utils";

interface progressBarProp {
    width: number;
};

export const Progressbar: React.FC<progressBarProp> = (props: progressBarProp) => {
    const {
        width
    } = props

    return (
        <div className="progress-bar">
            <div className="blue-progress">
                <div className={`percent ${(width < 50) ? '' : 'white'} ${(width < 99.99 ? '' : ' processing')}`}>{`${width < 99.99 ? (round(width) + '%') : 'Processing...'}`}</div>
                <div className="fill-bar" style={{ width: `${width}%` }}></div>
            </div>
        </div>
    );
};

export default Progressbar;
